import React, { Component } from 'react';
import { Button, Col, Icon, message, Row, Table } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';

import {
  queryDeleteInvoice,
  queryExportInvoice,
  queryInvalidInvoice,
  queryInvoiceList,
  queryRedInvoice,
  queryRestoreInvoice,
  queryUseInvoice,
  queryUseInvoiceEdit,
} from '@api/xxcrm/invoice';

import { queryAccountInfo, queryAccountList } from '@api/core/user';
import { queryOrgList } from '@api/core/org';
import util from '@util';
import base from '@util/base';

import { getContractType } from '@store/modules/contract_type';
import { queryRecycleContract } from '@api/xxcrm/contract';
import ModalUse from './ModalUse';
import ModalAdd from './ModalAdd';
import SearchForm from './FormSearch';
import ModalTip from './ModalTip';
import ModalRecord from './ModalRecord';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pageNo: 1,
      useModalVisible: false,
      useEditModalVisible: false,
      addModalVisible: false,
      recordModalVisible: false,
      tipModalVisible1: false,
      tipModalVisible2: false,
      tipModalVisible3: false,
      tipModalVisible4: false,
      total: 0,
      isLoading: false,
      selectedRowKeys: [],
    };
  }

  componentWillMount() {
    this.useTime = '';
    this.status = '';
    this.type = '';
    this.no = '';
  }

  componentDidMount() {
    this.loadDate(1, 15);
    this.loadOrg();
    this.loadAccount();
  }

  /**
   * 获取用户信息
   */
  getAccountInfo = () => {
    queryAccountInfo();
  };

  loadDate = (pageNo, pageSize, no, useTime, status, type) => {
    const params = {};
    const context = this;
    const { pageNo: statePageNo } = this.state;
    const current = pageNo || statePageNo;
    params.limit = 15;
    params.start = current;
    params.no = statePageNo || this.no;
    params.createTime = useTime || this.useTime;
    params.type = type || this.type;
    if (!params.createTime) {
      delete params.createTime;
    }
    this.setState({
      pageNo: current,
      isLoading: true,
    });
    params.status = status || this.status;
    if (params.status < 0) {
      params.status = '';
    }
    if (params.type < 0) {
      params.type = '';
    }
    queryInvoiceList(params).then(res => {
      if (res.statusCode === 200) {
        res.data.map(item => {
          base.bank.map(item2 => {
            if (parseInt(item2.key, 10) === parseInt(item.collectBank, 10)) {
              item.collectBankFont = item2.name;
            }
            return item2;
          });
          return item;
        });
        context.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
        });
      }
    });
  };

  loadContractType = () => {
    getContractType();
  };

  search = condition => {
    const type = parseInt(condition.type, 10) >= 0 ? condition.type : '';
    const status = parseInt(condition.status, 10) >= 0 ? condition.status : '';
    this.no = condition.no ? condition.no : '';
    this.useTime = condition.useTime;
    this.status = status;
    this.type = type;
    this.loadDate(1, 15, condition.no, condition.useTime, condition.status, condition.type);
  };

  /**
   * 作废发票
   */
  invalidInvoice = () => {
    queryInvalidInvoice(this.state.selectedRowKeys).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 删除发票
   */
  deleteInvoice = () => {
    queryDeleteInvoice(this.state.selectedRowKeys).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 发票冲红
   */
  redInvoice = () => {
    queryRedInvoice(this.state.selectedRowKeys).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 恢复发票
   */
  restoreInvoice = () => {
    queryRestoreInvoice(this.state.selectedRowKeys).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   *获取用户列表
   */
  loadAccount = () => {
    queryAccountList().then(res => {
      if (res.statusCode !== 200) message.error(res.message);
    });
  };

  /**
   *获取用组织列表
   */
  loadOrg = () => {
    queryOrgList().then(res => {
      if (res.statusCode !== 200) message.error(res.message);
    });
  };

  /**
   * 回收发票
   */
  recycleContract = () => {
    queryRecycleContract(this.state.selectedRowKeys).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 使用发票
   */
  useInvoice = params => {
    params.uuid = this.invoiceUuid;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    queryUseInvoice(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
      } else {
        message.error(res.message);
      }
    });
    this.setState({
      selectedRowKeys: [],
    });
  };

  /**
   * 编辑使用发票
   */
  useInvoiceEdit = params => {
    params.uuid = this.invoiceUuid;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    queryUseInvoiceEdit(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
      } else {
        message.error(res.message);
      }
    });
    this.setState({
      selectedRowKeys: [],
    });
  };

  /**
   * 显示使用发票弹窗
   */
  showUseModal = (uuid, record) => {
    this.invoiceUuid = uuid;
    this.record = record;
    this.setState({
      useModalVisible: true,
    });
  };

  /**
   * 发票使用编辑
   */
  showUseEditModal = (uuid, record) => {
    this.invoiceUuid = uuid;
    this.record = record;
    this.setState({
      useEditModalVisible: true,
    });
  };

  /**
   * 显示删除操作确认框
   */
  showTipModal1 = () => {
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择待处理的发票！');
    } else {
      this.setState({
        tipModalVisible1: true,
      });
    }
  };

  /**
   * 显示作废操作确认框
   */
  showTipModal2 = () => {
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择待作废的发票！');
    } else {
      this.setState({
        tipModalVisible2: true,
      });
    }
  };

  /**
   * 显示遗失操作确认框
   */
  showTipModal3 = () => {
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择冲红的发票！');
    } else {
      this.setState({
        tipModalVisible3: true,
      });
    }
  };

  /**
   * 显示恢复操作确认框
   */
  showTipModal4 = () => {
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择待处理的发票！');
    } else {
      this.setState({
        tipModalVisible4: true,
      });
    }
  };

  cancel = () => {
    this.setState({
      useModalVisible: false,
      addModalVisible: false,
      recordModalVisible: false,
      tipModalVisible1: false,
      tipModalVisible2: false,
      tipModalVisible3: false,
      tipModalVisible4: false,
      useEditModalVisible: false,
    });
  };

  showModal = (type, contractUuid) => {
    /* 1使用丨2添加丨3批量添加丨4分配丨5发票申请 丨6操作记录 丨7同意使用 丨8拒绝使用 */
    if (type === 2) {
      this.setState({
        addModalVisible: true,
      });
    } else if (type === 6) {
      this.setState({
        recordModalVisible: true,
        contractUuid,
      });
    }
  };

  onSelectChange = selectedRowKeys => {
    this.setState({
      selectedRowKeys,
    });
  };

  columns = () => {
    return [
      {
        title: '发票编号',
        dataIndex: 'no',
        key: 'no',
        width: 150,
        fixed: 'left',
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        fixed: 'left',
        render: text => {
          let status = '';
          if (text === 1) {
            status = '未使用';
          } else if (text === 2) {
            status = '已使用';
          } else if (text === 3) {
            status = '已作废';
          } else if (text === 4) {
            status = '已冲红';
          }
          return <span>{status}</span>;
        },
      },
      {
        title: '类型',
        dataIndex: 'invoiceType',
        key: 'invoiceType',
        width: 150,
        render: (text, record) => {
          let type = '';
          if (text === '1') {
            type = '国税网络在线发票';
          } else if (text === '2') {
            type = '增值税专用发票';
          } else {
            type = '增值税普通发票';
          }
          return <span>{type}</span>;
        },
      },
      {
        title: '金额',
        dataIndex: 'price',
        key: 'price',
        width: 100,
        render: text => {
          return <span>{text > 0 ? text : ''}</span>;
        },
      },
      {
        title: '发票抬头',
        dataIndex: 'invoiceTop',
        key: 'invoiceTop',
        width: 150,
      },
      {
        title: '合同编号',
        dataIndex: 'contractNo',
        key: 'contractNo',
        width: 150,
      },
      {
        title: '开票类型',
        dataIndex: 'submitType',
        key: 'submitType',
        width: 100,
        render: text => {
          let type = '';
          if (text === 1) {
            type = '提前开票';
          } else if (text === 2) {
            type = '到账开票';
          }
          return <span>{type}</span>;
        },
      },
      {
        title: '开票日期',
        dataIndex: 'useTime',
        key: 'useTime',
        width: 150,
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '购方名称',
        dataIndex: 'name',
        key: 'name',
        width: 150,
      },
      {
        title: '购方税号',
        dataIndex: 'taxId',
        key: 'taxId',
        width: 180,
      },
      {
        title: '不含税金额',
        dataIndex: 'noTaxPrice',
        key: 'noTaxPrice',
        width: 150,
        render: text => {
          return <span>{text > 0 ? text : ''}</span>;
        },
      },
      {
        title: '税率',
        dataIndex: 'taxRate',
        key: 'taxRate',
        width: 100,
        render: text => {
          return <span>{text > 0 ? text : ''}</span>;
        },
      },
      {
        title: '合计税额',
        dataIndex: 'totalPrice',
        key: 'totalPrice',
        width: 150,
        render: text => {
          return <span>{text > 0 ? text : ''}</span>;
        },
      },
      {
        title: '到账日期',
        dataIndex: 'collectDate',
        key: 'collectDate',
        width: 150,
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '收款方式',
        dataIndex: 'collectWay',
        key: 'collectWay',
        width: 150,
        render: text => {
          let type = '';
          if (text === 1) {
            type = '汇款';
          } else if (text === 2) {
            type = '现金';
          }
          return <span>{type}</span>;
        },
      },
      {
        title: '收款银行',
        dataIndex: 'collectBankFont',
        key: 'collectBankFont',
        width: 190,
      },
      {
        title: '本月开票金额是否与到账金额相符',
        dataIndex: 'isCorrect',
        key: 'isCorrect',
        width: 250,
        render: text => {
          let isCorrect = '';
          if (text === 0) {
            isCorrect = '否';
          } else if (text === 1) {
            isCorrect = '是';
          }
          return <span>{isCorrect}</span>;
        },
      },
      {
        title: '首款金额',
        dataIndex: 'firstPrice',
        key: 'firstPrice',
        width: 150,
        render: text => {
          return <span>{text > 0 ? text : ''}</span>;
        },
      },
      {
        title: '尾款金额',
        dataIndex: 'balancePrice',
        key: 'balancePrice',
        width: 150,
        render: text => {
          return <span>{text > 0 ? text : ''}</span>;
        },
      },
      {
        title: '回执单收回日期',
        dataIndex: 'recoverDate',
        key: 'recoverDate',
        width: 150,
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '申请人部门',
        dataIndex: 'orgName',
        key: 'orgName',
        width: 150,
      },
      {
        title: '开票人',
        dataIndex: 'applyUserName',
        key: 'applyUserName',
        width: 100,
      },
      {
        title: '申请人',
        dataIndex: 'cusrName',
        key: 'cusrName',
        width: 100,
      },
      {
        title: '领取人',
        dataIndex: 'receiveUserName',
        key: 'receiveUserName',
        width: 100,
      },
      {
        title: '备注',
        dataIndex: 'remark',
        key: 'remark',
        width: 150,
      },
      {
        title: '操作',
        key: 'done',
        width: 100,
        fixed: 'right',
        render: (rext, record) => (
          <span>
            {record.status === 1 ? (
              <span>
                <a onClick={() => this.showUseModal(record.uuid, record)}>使用</a>
              </span>
            ) : (
              ''
            )}
            {/* <a onClick={() => this.showModal(6,record.uuid)}>查看</a> */}
            {record.status === 2 ? (
              <span>
                <a onClick={() => this.showUseEditModal(record.uuid, record)}>编辑</a>
              </span>
            ) : (
              ''
            )}
          </span>
        ),
      },
    ];
  };

  /**
   * 导出发票
   */
  exportContract = () => {
    const params = {};
    params.no = this.no;
    if (params.useTime) {
      params.useTime = this.useTime;
    }
    params.status = this.status;
    params.type = this.type;
    queryExportInvoice(params);
  };

  render() {
    const { data, total, selectedRowKeys, isLoading } = this.state;
    const pagination = {
      total,
      showSizeChanger: false,
      pageSize: 15,
      current: this.state.pageNo,
      onChange: current => {
        this.loadDate(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const tH = util.pageHeight() - 288;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const {
      useModalVisible,
      addModalVisible,
      tipModalVisible1,
      useEditModalVisible,
      recordModalVisible,
      tipModalVisible2,
      tipModalVisible3,
      tipModalVisible4,
    } = this.state;
    return (
      <div className="fixed-box">
        <div className="fixed-header">
          <Row type="flex" className="btn-group">
            <Col span={16}>
              <ul className="table-menu">
                <li onClick={() => this.showModal(2)}>
                  <Icon type="addc" />
                  <span>添加</span>
                </li>
                <li onClick={this.showTipModal4}>
                  <Icon type="recover" />
                  <span>恢复</span>
                </li>
                <li onClick={this.showTipModal1}>
                  <Icon type="deletec" />
                  <span>删除</span>
                </li>
                <li onClick={this.showTipModal2}>
                  <Icon type="cancel" />
                  <span>作废</span>
                </li>
                <li onClick={this.showTipModal3}>
                  <Icon type="lose" />
                  <span>冲红</span>
                </li>
              </ul>
            </Col>
            <Col span={8}>
              <Row type="flex" justify="end" className="btn-group">
                <Col>
                  <Button onClick={this.exportContract}>导出</Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="space-between" type="flex" style={{ marginBottom: '16px' }}>
            <Col span={24}>
              <SearchForm search={this.search} />
            </Col>
          </Row>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={rowSelection}
          columns={this.columns()}
          dataSource={data}
          loading={isLoading}
          pagination={pagination}
          style={{ paddingTop: '113px' }}
          scroll={{ x: 3600, y: tH }}
        />
        {/* 弹窗 */}
        {useModalVisible ? (
          <ModalUse cancel={this.cancel} handSubmit={this.useInvoice} record={this.record} />
        ) : (
          ''
        )}
        {useEditModalVisible ? (
          <ModalUse cancel={this.cancel} handSubmit={this.useInvoiceEdit} record={this.record} />
        ) : (
          ''
        )}
        {addModalVisible ? <ModalAdd cancel={this.cancel} loadDate={this.loadDate} /> : ''}
        {tipModalVisible1 ? <ModalTip cancel={this.cancel} handSubmit={this.deleteInvoice} /> : ''}
        {tipModalVisible2 ? <ModalTip cancel={this.cancel} handSubmit={this.invalidInvoice} /> : ''}
        {tipModalVisible3 ? <ModalTip cancel={this.cancel} handSubmit={this.redInvoice} /> : ''}
        {tipModalVisible4 ? <ModalTip cancel={this.cancel} handSubmit={this.restoreInvoice} /> : ''}
        {recordModalVisible ? (
          <ModalRecord cancel={this.cancel} contractUuid={this.state.contractUuid} />
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default connect(state => ({
  list: state.contract_type,
  account_info: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/invoice/Index.js